import { RolloutProgressReportEntities } from '../../../shared/self-inspection-reports/service/entities';
import { ReportFilterType } from '../../utils/report-row.helper';

export const reportsPanelTypeOptions: {
  label: string;
  value: ReportFilterType;
}[] = [
  {
    label: 'reportsPanel.types.span',
    value: RolloutProgressReportEntities.v3.MarkerTypes.SPAN,
  },
  {
    label: 'reportsPanel.types.cabinet',
    value: RolloutProgressReportEntities.v3.MarkerTypes.CABINET,
  },
  {
    label: 'reportsPanel.types.manhole',
    value: RolloutProgressReportEntities.v3.MarkerTypes.MANHOLE,
  },
  {
    label: 'reportsPanel.types.kp',
    value: RolloutProgressReportEntities.v3.MarkerTypes.HP,
  },
  {
    label: 'reportsPanel.types.hc',
    value: RolloutProgressReportEntities.v3.MarkerTypes.HC,
  },
  {
    label: 'reportsPanel.types.site',
    value: RolloutProgressReportEntities.v3.MarkerTypes.SITE,
  },
  {
    label: 'reportsPanel.types.hub',
    value: RolloutProgressReportEntities.v3.MarkerTypes.HUB,
  },
];
